module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Koelliken_AG-e889379b523ffd277e487e5aba8ba26d.svg";